<template>
  <div class="relative w-full">
    <div
      class="absolute -left-px -top-px bottom-[-2px] right-[-2px] rounded-lg bg-gradient-to-br from-secondary to-primary opacity-50 blur-sm"
    />

    <RouterLink
      :to="to"
      class="relative block w-full rounded-lg bg-background py-4"
    >
      <div class="flex flex-col items-center">
        <Component :is="icon" class="mb-2" />
        <p class="text-xl font-semibold">
          <slot />
        </p>
      </div>
    </RouterLink>
  </div>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router"
import type { Component } from "vue"

defineProps<{
  to: RouteLocationRaw
  icon: Component
}>()
</script>
